import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const UpdateBasePriceAdditionsBlockStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "update-base-price-additions-block",
  },
)`
  margin-top: 8px;

  & .section-title {
    font-weight: 600;
    margin-bottom: 6px;
  }

  & .section-hint {
    font-size: 13px;
    line-height: 1.4;
    opacity: 0.9;
    margin-bottom: 10px;
  }
`;
